/* eslint-disable */


/**
 * Create styles for `<OrderConfirmationButton />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<OrderConfirmationButton />` styles
 */
const orderConfirmationButtonStyles = ({ theme }) => ({
  cancelButton: {
    backgroundColor: `#D1D5D9`,
    borderRadius: theme.shape.borderRadius,
    justifyContent: `left`,
  },
  cancelIcon: {
    marginLeft: theme.spacing(1),
  },
  confirmation: {
    '&:hover': {
      background: `#77AEAA`,
    },
    backgroundColor: `#95DAD5`,
    borderRadius: theme.shape.borderRadius,
    height: theme.spacing(1) * 7,
    justifyContent: `left`,
  },
  confirmationButton: {
    '&:hover': {
      background: `#77AEAA`,
    },
    backgroundColor: `#95DAD5`,
    borderRadius: theme.shape.borderRadius,
    justifyContent: `left`,
  },
  tick: {
    marginLeft: theme.spacing(1) * 2,
  },
});

export default orderConfirmationButtonStyles;
